import { mixins } from '../styles';

export const defaultTheme = {
  id: 'default',
  logoTitle: '',
  colors: {
    inner: `${mixins.colors.black}`,
    background: `${mixins.themeColors.default}`,
  },
} as const;

export type DefaultTheme = typeof defaultTheme;
export const createDefaultTheme = (): DefaultTheme => defaultTheme;

export const knowledgeTheme = {
  id: 'knowledge',
  logoTitle: '看護知識',
  colors: {
    inner: `${mixins.colors.white}`,
    background: `${mixins.themeColors.knowledge}`,
  },
};
export type KnowledgeTheme = typeof knowledgeTheme;
export const createKnowledgeTheme = (): KnowledgeTheme => knowledgeTheme;

export const squareTheme = {
  id: 'square',
  logoTitle: '看護記事',
  colors: {
    inner: `${mixins.colors.white}`,
    background: `${mixins.themeColors.square}`,
  },
};
export type SquareTheme = typeof squareTheme;
export const createSquareTheme = (): SquareTheme => squareTheme;

export const loungeTheme = {
  id: 'lounge',
  logoTitle: '掲示板',
  colors: {
    inner: `${mixins.colors.white}`,
    background: `${mixins.themeColors.lounge}`,
  },
} as const;
export type LoungeTheme = typeof loungeTheme;
export const createLoungeTheme = (): LoungeTheme => loungeTheme;
